import RealEstateLogoImg from "@/assets/realestate.png";
import { LogoImage, LogoProps } from "../LogoImage";

type Props = Omit<LogoProps, "imgSrc" | "alt">;

export const RealEstateLogo = (props: Props) => (
  <LogoImage imgSrc={RealEstateLogoImg} alt="Real Estate Logo" size="navbar" {...props} />
);
